import { DiagnosisListComponent } from "./components/diagnosis-list/diagnosis-list.component";
import { TrainingInitateComponent } from "./components/train-bot/training-initate/training-initate.component";
import { TrainingComponent } from "./components/train-bot/training/training.component";
import { TrainBotComponent } from "./components/train-bot/train-bot.component";
import { MoreComponent } from "./components/more/more.component";
import { GameBotComponent } from "./components/game-bot/game-bot.component";

import { NonRegisterComponent } from "./components/non-register/non-register.component";
import { BotUtilityEditComponent } from "./components/bot-info/bot-edit/bot-utility-edit/bot-utility-edit.component";
import { UtilityDetailsComponent } from "./components/bot-info/bot-details/utility-details/utility-details.component";

import { HomeDetailsComponent } from "./components/bot-info/bot-details/home-details/home-details.component";
import { BotInfoDetailsComponent } from "./components/bot-info/bot-details/bot-info-details/bot-info-details.component";
import { BotDetailsComponent } from "./components/bot-info/bot-details/bot-details.component";

import { EditProfileComponent } from "./components/user-profile/edit-profile/edit-profile.component";
import { BotInfoComponent } from "./components/bot-info/bot-info.component";
import { ApplianceServiceComponent } from "./components/vyas/create-edit-appliance/appliance-service/appliance-service.component";
import { DiagnosisInitateComponent } from "./components/diagnosis-initate/diagnosis-initate.component";
import { SupportComponent } from "./components/support/support.component";
import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { LoginComponent } from "./components/login/login.component";
import { ProfileComponent } from "./components/profile/profile.component";
import { DashbaordComponent } from "./components/dashbaord/dashbaord.component";
import { AnalysisComponent } from "./components/analysis/analysis.component";
import { BudgetComponent } from "./components/budget/budget.component";
import { DisplayProfileComponent } from "./components/display-profile/display-profile.component";
import { UserProfileComponent } from "./components/user-profile/user-profile.component";
import { VyasComponent } from "./components/vyas/vyas.component";
import { DiagnosisComponent } from "./components/diagnosis/diagnosis.component";
import { ReferralComponent } from "./components/referral/referral.component";
import { CreateEditApplianceComponent } from "./components/vyas/create-edit-appliance/create-edit-appliance.component";
import { ApplianceDetailsComponent } from "./components/vyas/appliance-details/appliance-details.component";
import { DashboardRightComponent } from "./components/dashbaord/dashboard-right/dashboard-right.component";
import { HomeDetailsEditComponent } from "./components/bot-info/bot-edit/home-details-edit/home-details-edit.component";
import { BotInfoEditComponent } from "./components/bot-info/bot-edit/bot-info-edit/bot-info-edit.component";
import { VyasOnboardingComponent } from "./components/vyas/vyas-onboarding/vyas-onboarding.component";

const routes: Routes = [
  { path: "", redirectTo: "login", pathMatch: "full" },
  { path: "login", component: LoginComponent },
  { path: "profile", component: DisplayProfileComponent },
  { path: "dashboard", component: DashbaordComponent },
  { path: "analysis", component: AnalysisComponent },
  { path: "budget", component: BudgetComponent },
  { path: "user-profile", component: UserProfileComponent },
  { path: "vyas", component: VyasComponent },
  { path: "diagnose", component: DiagnosisListComponent },
  { path: "diagnose/:appliance_id", component: DiagnosisComponent },
  {
    path: "diagnose-initate/:appliance_id/:applianceName/:stabilityAverage",
    component: DiagnosisInitateComponent,
  },
  { path: "referral", component: ReferralComponent },
  { path: "create-appliance", component: CreateEditApplianceComponent },
  {
    path: "edit-appliance/:appliance_id",
    component: CreateEditApplianceComponent,
  },
  {
    path: "add-service/:appliance_id",
    component: ApplianceServiceComponent,
  },
  {
    path: "view-appliance/:appliance_id",
    component: ApplianceDetailsComponent,
  },
  { path: "support", component: SupportComponent },
  { path: "bot-info", component: BotInfoComponent },
  { path: "bot-details/:meter_id", component: BotDetailsComponent },
  { path: "bot-info-details/:meter_id", component: BotInfoDetailsComponent },
  { path: "bot-home-details/:meter_id", component: HomeDetailsComponent },
  {
    path: "bot-home-details-edit/:meter_id",
    component: HomeDetailsEditComponent,
  },
  { path: "bot-info-edit/:meter_id", component: BotInfoEditComponent },
  { path: "bot-utility-details/:meter_id", component: UtilityDetailsComponent },
  { path: "bot-utility-edit/:meter_id", component: BotUtilityEditComponent },
  { path: "edit-profile", component: EditProfileComponent },
  { path: "dashboard-right", component: DashboardRightComponent },
  { path: "unregister", component: NonRegisterComponent },
  { path: "vyas-onboarding", component: VyasOnboardingComponent },
  { path: "game-bot/:appliance_id", component: GameBotComponent },
  { path: "more", component: MoreComponent },
  { path: "train-bot", component: TrainBotComponent },
  { path: "train-bot/:appliance_id", component: TrainingComponent },
  {
    path: "training-initate/:appliance_id/:applianceName/:stabilityAverage",
    component: TrainingInitateComponent,
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
